export default __webpack_public_path__ + "d2d825f49d50fc1f6b114940ace97654.svg";